import { http } from 'services/http';
import type { DocumentSignedUrlRes } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

type THandleSuccessFn = (data: DocumentSignedUrlRes) => void;

interface IDownloadDocumentMutationOptions {
  handleSuccess?: THandleSuccessFn;
}

interface IDownloadDocumentVariables {
  documentId: number;
}

export const useGetDocumentLink = (options?: IDownloadDocumentMutationOptions) => {
  return useMutationBase<DocumentSignedUrlRes, unknown, IDownloadDocumentVariables>({
    mutationFn: async (variables) => {
      const { documentId } = variables;
      const res = await http.get<DocumentSignedUrlRes>(`/v1/documents/${documentId}/link`);

      return res.data;
    },

    onSuccess: options?.handleSuccess,
  });
};
